const BASE_URL = process.env.REACT_APP_APPS_SCRIPT_URL;

async function get(action, params = {}) {
  const urlParams = new URLSearchParams({ action, ...params });
  const res = await fetch(`${BASE_URL}?${urlParams.toString()}`);
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

async function post(body) {
  const params = new URLSearchParams({ action: body.action, data: JSON.stringify(body) });
  const res = await fetch(`${BASE_URL}?${params.toString()}`);
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

export const createProductionLog = (category, data) =>
  post({ action: 'createProductionLog', category, data });

export const getProductionLogs = (category) =>
  get('getProductionLogs', { category });

export const getProductionLogById = (category, batchId) =>
  get('getProductionLogById', { category, batchId });

export const updateProductionLog = (category, batchId, data) =>
  post({ action: 'updateProductionLog', category, batchId, data });

export const deleteProductionLog = (category, batchId) =>
  post({ action: 'deleteProductionLog', category, batchId });

export const getARtoCCSales = (startDate, endDate) =>
  post({ action: 'getARtoCCSales', startDate, endDate });

export const getFlavors = (category) =>
  get('getFlavors', { category });

export const addFlavor = (category, flavor) =>
  post({ action: 'addFlavor', category, flavor });

export const getPHTargets = () =>
  get('getPHTargets');

export const updatePHTarget = (category, readingName, targetPH) =>
  post({ action: 'updatePHTarget', category, readingName, targetPH });

export const fileBatch = (category, batchId) =>
  post({ action: 'fileBatch', category, batchId });

export const generateNewBatchId = (category, flavor) =>
  get('generateNewBatchId', { category, flavor });

export const getIngredientPrices = () =>
  get('getIngredientPrices');

export const saveIngredientPrice = (ingredient, unit, price_per_unit) =>
  post({ action: 'saveIngredientPrice', ingredient, unit, price_per_unit });

export const syncIngredientsFromProductionLog = () =>
  post({ action: 'syncIngredientsFromProductionLog' });
